import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavController, MenuController } from '@ionic/angular';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';


@Component({
  selector: 'app-popupconfig',
  templateUrl: './popupconfig.page.html',
  styleUrls: ['./popupconfig.page.scss'],
})
export class PopupconfigPage implements OnInit {

  popupconfig: any;
  sample: any;

  constructor(public _sanitizer: DomSanitizer, 
    public navctrl: NavController, 
    public menu: MenuController,
    public api: RestapiService, 
    public cmndef: CommonDefinitionService,) {
    let d = localStorage.getItem('configPage');
    let dparse = JSON.parse(d);
    console.log(dparse);
    dparse = dparse.values;
    var count = 1;
    var df = [];
    for (var s = 0; s < dparse.length; s++) {
      count = count + 1;
      if (dparse[s].popupType == 'P' && dparse[s].popupDeviceType == 'A') {
        df.push('0');
      } else {
        df.push('1');
      }
    }
    var bannnervisited = localStorage.getItem('banner');
    localStorage.removeItem('banner');
    if (df.indexOf("0") !== -1) {
    // if (df.indexOf("0") !== -1 && bannnervisited != 'displayed') {
      // this.popupconfig = dparse[0].popupContent;
      // this.popupconfig = `<div id="enachpopup"><div><div><img onclick="var script = document.createElement('script');script.type = 'text/javascript'; script.src = 'https://akeiradev.uniphore.com/Images/settings.js';document.getElementsByTagName('head')[0].appendChild(script); localStorage.banner = 'displayed';localStorage.proshowtouse = '';pageredirect();localStorage.promotion = 'displayed';" src="https://akeiradev.uniphore.com/Images/close.png" alt="pnblogo" style="z-index: 1;width: 45px;position: fixed;right: 0;"></div><div> <img style="width: 100%;height: 30%; top: 0; position: absolute;" src="https://akeiradev.uniphore.com/Images/20th_Anniversary_banner_khushi.jpg"></div><div> <button onclick="var script = document.createElement('script');script.type = 'text/javascript';document.getElementsByTagName('head')[0].appendChild(script);redirectToJourney();" style="background-color: #4CAF50; border: none; color: white; padding: 15px 32px; text-align: center; text-decoration: none; display: inline-block; font-size: 15px; margin: 0px 2px; cursor: pointer; left: 62%; position: absolute; margin-left: -115px; top: 34%; font-weight: bold;" class="button">KNOW MORE</button></div><div> <img style="width: 100%; height: 30%; top: 55%; position: absolute;" src="https://akeiradev.uniphore.com/Images/20th_Anniversary_banner_khushi.jpg"></div><div> <button style="background-color: #4CAF50; border: none; color: white; padding: 15px 32px; text-align: center; text-decoration: none; display: inline-block; font-size: 15px; margin: 30px 2px; cursor: pointer; left: 50%; bottom: 0%; position: absolute; margin-left: -73px; font-weight: bold;" class="button">KNOW MORE</button></div></div></div>`;
    } else{
      sessionStorage.CurrentPage="/va/chat"
      this.navctrl.navigateRoot("/va/chat");
    }
      
    this.redirectPaging();

  }

  ionViewWillEnter() {
    this.menu.swipeEnable(false);
  }

  ngOnInit() {

  }
  teleDoctorSubmit() {
    sessionStorage.CurrentPage="/va/vasdetails"
    this.api.clickenventcap("teleDoctorBanner");
    this.cmndef.selectedVAS = "teledoctor";
    this.navctrl.navigateRoot("/va/vasdetails");
  }

  healthSubmit() {
    this.cmndef.selectedVAS = "health";
    this.api.clickenventcap("healthAndWellnessBanner");
    sessionStorage.CurrentPage="/va/vasdetails"
    this.navctrl.navigateRoot("/va/vasdetails");
  }

  redirectToChat() {
    sessionStorage.CurrentPage="/va/chat"
    this.navctrl.navigateRoot("/va/chat");
  }

  redirectPaging() {
    let setInt: any
    setInt = setInterval(() => {
      if (localStorage.banner != undefined && localStorage.banner != "") {
        clearInterval(setInt);
        sessionStorage.CurrentPage="/va/chat"
        this.navctrl.navigateRoot("/va/chat");
      }
    }, 1000)
  }

}
